import { useEffect } from "react";
import config from "../config";

function LandingPage() {
  useEffect(() => {
    const baseUrl = config.host_url.replace(/\/$/, '');
    const homepagePath = `${baseUrl}${config.path_prefix}homepage.html`;
    window.location.href = homepagePath;
  }, []);

  return null;
}

export default LandingPage;